import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      d: "M29.262 14.015c-.01 3.405-.563 7.073-5.1 8.82-4.536-1.747-5.09-5.415-5.099-8.82z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M24.163 22.836c2.057-.792 3.294-1.98 4.034-3.358a6 6 0 0 1-.443-.009c-.111-.007-4.35-.42-4.852-.6-.436-.155-2.102.133-2.88.403.726 1.466 1.982 2.732 4.14 3.564"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      d: "M20.993 20.725c.069-.022 1.436-.11 1.436-.197s0-.41-.084-.712c-.083-.302-.558-.545-.541-.62.067.005 1.138-.277 1.138-.353 0-.598-.85-1.78-.898-2.552-.014-.213-.011-.688-.1-.764-.151-.12-.224-.097-.324-.135-.073-.098-.106-.293-.173-.466-.328.086-.39.53-.49.682-.101.152-.268.109-.408.336-.306-.363-.312-.466-.334-.569s-.073-.124-.246-.27c0-.044-.022-.217-.005-.315-.129-.103-.223-.086-.285-.01-.061.075-.429.48-.57.69.128 1.886.566 3.758 1.883 5.255"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M29.262 14.015c.004-1.282-.07-2.527-.036-3.619-1.695-.737-3.926-.888-5.063-.888-1.138 0-3.369.151-5.064.888.034 1.092-.04 2.337-.036 3.62z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M22.995 10.351c-.17.005-.54.008-.617.05-.078.043-.112.062.024.085s.366.087.492.162.231.209.197.4c-.105.571.203 1.121.65 1.329.042.02.004.32-.02.353s-.036.087.041.061c-.053.097-.172.29-.208.34-.357-.043-.647.004-.674.367-.003.036.01.092.065.003.056-.09.119-.175.272-.198-.09.134-.12.254-.104.332.014.078.036.125.075.026a.6.6 0 0 1 .186-.248c.03-.02.037.229.08.274.044.044.066.026.054-.047-.012-.074.006-.226.099-.274.133-.068.247-.033.3.057.054.09.1.005.042-.097-.058-.101-.12-.172-.216-.179.085-.146.184-.323.206-.358.022-.036.133-.012.163-.07.029-.06.08-.234.152-.305.037-.01.095-.023.116-.042.095.134.18.283.202.316.021.032.046.047.024.115s-.097.285-.109.332c-.264.01-.385.014-.47.158-.037.063.021.087.085.054a.4.4 0 0 1 .198-.054c.046.007-.242.229-.235.365.002.05.023.075.063.008a.46.46 0 0 1 .281-.215c-.007.115.02.285.092.32.073.036.078 0 .051-.068a.27.27 0 0 1 .056-.275c.114-.123.373.047.422.09.048.041.093.06.065-.05-.036-.146-.25-.231-.431-.255.05-.238.186-.719.26-.884.106.057.19-.092.368-.028.3.108.751.382.829.443s.252.014.305.024c.053.009.102.023.034-.109a1.5 1.5 0 0 0-.51-.542c.166.014.389.014.389-.028s-.257-.123-.364-.132c.102-.024.257-.08.33-.16.043-.048-.858-.067-1.1-.203-.388-.217-.61-.445-.8-.542-.102-.052-.164-.172-.204-.275-.126-.33-.12-.478-.415-.587-.296-.108-.636.024-.791.161"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M21.375 17.953c.61.056 1.184.696 2.056.974.544.172 1.47.074 1.897.088.317.01.285-.784 1.205-.784 0 0 1.557-.094 1.954-.096-.037.484-.624 1.498-.624 1.498l-4.063.1s-1.642-1.31-2.425-1.78",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagShn = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagShn_default = SvgFlagShn;

export { FlagShn_default as default };
